import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/storage'
import store from '@/store'

if (!firebase.apps.length) {
  firebase.initializeApp({
    apiKey: process.env.FB_API_KEY,
    projectId: process.env.FB_PROJECT_ID,
    authDomain: `${process.env.FB_PROJECT_ID}.firebaseapp.com`,
    databaseURL: `https://${process.env.FB_PROJECT_ID}.firebaseio.com`,
    storageBucket: `gs://${process.env.FB_PROJECT_ID}.appspot.com`
  })
}

const maxSigninAttempts = 3
const signinRetryDelay = 500

firebase.projectBoard = {
  signIn: function (options) {
    options = options || {}
    return new Promise((resolve, reject) => {
      this.getTokenAndSignIn(options, resolve, reject)
    })
  },

  getToken: function (reset) {
    return store.dispatch('getFirebaseToken', reset)
  },

  getTokenAndSignIn: function (options, resolve, reject, attempt) {
    attempt = attempt || 1
    const retry = () => {
      if (attempt < maxSigninAttempts) {
        setTimeout(() => { this.getTokenAndSignIn(options, resolve, reject, attempt + 1) }, signinRetryDelay * attempt)
      } else {
        reject()
      }
    }

    const resetToken = attempt > 1
    this.getToken(resetToken).then((token) => {
      if (token) {
        firebase.auth().signInWithCustomToken(token).then(() => {
          resolve()
        }).catch((error) => {
          if (error.code !== 'auth/user-token-expired' && error.code !== 'auth/invalid-custom-token') {
            console.error(`Unable to signin to firebase: ${error}; (${error.code})`)
          }
          retry()
        })
      } else if (options.allowAnonymous) {
        firebase.auth().signInAnonymously().then(() => {
          resolve()
        }).catch((error) => {
          console.error(`Unable to signin anonymously to firebase: ${error}; (${error.code})`)
          reject()
        })
      } else {
        console.error('Failed to get firebase token: missing token')
        retry()
      }
    }).catch((error) => {
      console.error(`Failed to get firebase token: ${error}; (${error.code})`)
      retry()
    })
  }
}

export default firebase
